// extracted by mini-css-extract-plugin
export var main = "landing-content-module--main--2eda3";
export var remote = "landing-content-module--remote--20506";
export var video = "landing-content-module--video--cad90";